<template>
  <layout-main-inner :title="`经销商收货方管理——${config.customerName}`">
    <layout-card-wrap
      v-loading="loading"
      hasHeaderSlot>
      <template slot="title">
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="createDelivery">新建收货信息</el-button>
      </template>
      <template slot="form">
        <!-- <el-input
          v-model="config.deliveryName"
          placeholder="请输入收货方"
          clearable
          style="width: 200px;margin-right: 5px"
          @change="handleCurrentChange(1)"
          @clear="handleCurrentChange(1)">
        </el-input> -->
        <el-input
          v-model="config.deliveryPhone"
          placeholder="请输入联系电话"
          clearable
          style="width: 200px"
          @change="handleCurrentChange(1)"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="收货方名称"
        >
          <template slot-scope="{row}">
            <link-route :link-to="`/customer-delivery-detail?vendorId=${row.vendorId}&deliveryAddressId=${row.deliveryAddressId}&customerId=${row.customerId}`">
              {{ row.deliveryName }}
            </link-route>
          </template>
        </el-table-column>
        <el-table-column
          label="联系电话"
          width="160"
          prop="deliveryPhone"></el-table-column>
        <el-table-column
          label="收货地址"
          width="300">
          <template slot-scope="{row}">
            {{ row.provinceName }}-{{ row.cityName }}-{{ row.areaName }}-{{ row.detailedAddress }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="销售区域"
          prop="saleAreaName"></el-table-column> -->
        <el-table-column
          width="150"
          label="创建时间"
          prop="createdTime">
          <template slot-scope="{row}">
            {{ row.createdTime | dateformat() }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="100">
          <template slot-scope="{row}">
            <el-button
              type="danger"
              @click="deleteDelivery(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <el-pagination
          background
          :current-page.sync="config.pageNum"
          :page-size="config.pageSize"
          layout="total, prev, pager, next"
          :total="total"
          @current-change="handleCurrentChange">
        </el-pagination>
      </template>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'DeliveryList',
  data() {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        vendorId: null,
        deliveryPhone: '',
        customerId: null,
        customerName: null
      },
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      query: state => state.common.query
    })
  },
  created() {
    if (this.query) {
      this.config = {
        ...this.config,
        ...this.query
      }
    }
    this.config.customerId = this.$route.query.customerId
    this.config.customerName = this.$route.query.customerName
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    createDelivery() {
      this.$router.push(`/customer-delivery-edit?vendorId=${this.userInfo.orgId}&customerId=${this.config.customerId}`)
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('delivery/getdeliveryaddresses', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    deleteDelivery(row) {
      this.$confirm('此操作将永久删除该收货方信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('delivery/deletedeliveryaddress', {
            payload: {
              deliveryAddressId: row.deliveryAddressId,
              vendorId: row.vendorId
            },
            success: () => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    }
  }
}
</script>
